export default __webpack_public_path__ + "static/media/img-1.5cc860d7.png";